export default "__VITE_ASSET__BgGth7W2__"